export default __webpack_public_path__ + "static/media/MURLI SUNDARAM.a169aa29.jpg";